<template>
  <main class="page-investors-dashboard">
    <div class="container">
      <PageTitle class="mb-5">Aziende</PageTitle>
        <div class="row" v-if="companies && companies.length > 0">
          <div class="col-lg-4 col-md-6 mb-4" v-for="(company, index) in companies" :key="index">
            <LawaCard :name="company.name" :avatar="company.logo">
              <h4 class="font-weight-bold truncated-text" :title="company.name">{{ company.name }}</h4>
              <p class="small text-uppercase mb-1">
                <strong>P.IVA:</strong>
                {{ company.vat }}
              </p>

              <template #footer>
                <router-link class="btn btn-primary btn-sm" :to="{ name: 'operative-company', params: { id: company.id } }">
                  <!-- TODO: Il link al dettaglio azienda redirecta alla dashboard -->
                  Visualizza
                </router-link>
              </template>
            </LawaCard>
          </div>
        </div>
        <template v-else>
          <AlertFeedback status="info" class="w-100">
            <h4 class="alert-heading">Nessuna azienda disponibile</h4>
            <p>Non sono presenti aziende disponibili...</p>
        </AlertFeedback>
        </template>
    </div>
  </main>
</template>

<script>
import $api from '../../../../libs/Api/services/api';

export default {
  name: 'page-investors-dashboard',
  components: {
    PageTitle: () => import('../../../components/Layout/LayoutOperative/PageTitle'),
    LawaCard: () => import('../../../components/Layout/Card/LawaCard'),
    AlertFeedback: () => import('../../../../libs/Feedback/components/Alert'),
  },
  data () {
    return {
      companies: [],
    };
  },
  async beforeRouteEnter (to, from, next) {
    try {
      const res = await $api.companies();
      return next(vm => {
        vm.companies = res.data?.companies || [];
      });
    } catch (error) {
      return next(vm => vm.$log.error(error));
    }
  },
};

</script>

<style lang="scss">
</style>
